import * as React from 'react';

const BellSoundingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 48 47" fill="none" {...props}>
        <path
            d="M41.751 24A18.12 18.12 0 0042 21a17.957 17.957 0 00-6.094-13.5M15 5.612c-5.38 3.112-9 8.93-9 15.592 0 1.022.085 2.024.249 3M46.653 25c.228-1.3.347-2.636.347-4 0-7.435-3.528-14.045-9-18.25"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 1C5.85 4.9 1 12.486 1 21.204c0 1.364.119 2.7.347 4M40 34H29.882M8 34h16.412H8zM28 8a4 4 0 00-8 0M29 41a5 5 0 01-10 0"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M36 21v10h2V21h-2zm4 18H8v2h32v-2zm-28-8V21h-2v10h2zM24 7c-7.732 0-14 6.268-14 14h2c0-6.627 5.373-12 12-12V7zm14 14c0-7.732-6.268-14-14-14v2c6.627 0 12 5.373 12 12h2zM8 35a4 4 0 004-4h-2a2 2 0 01-2 2v2zm-2 2a2 2 0 012-2v-2a4 4 0 00-4 4h2zm2 2a2 2 0 01-2-2H4a4 4 0 004 4v-2zm34-2a2 2 0 01-2 2v2a4 4 0 004-4h-2zm-2-2a2 2 0 012 2h2a4 4 0 00-4-4v2zm-4-4a4 4 0 004 4v-2a2 2 0 01-2-2h-2z"
            fill="#1D0A32"
        />
    </svg>
);

BellSoundingSvg.displayName = 'BellSoundingSvg';
export default BellSoundingSvg;
